module.exports = __webpack_public_path__ + "static/media/next.9a894ba6.svg";